import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Browser} from 'react-router-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import axios from 'axios';

import './index.css';
import App from './App';
import rootReducer from './store/combineReducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (process.env.REACT_APP_MOCK === 'run') {
  axios.defaults.baseURL = process.env.REACT_APP_MOCK_API_HOST;
} else {
  axios.defaults.baseURL = process.env.REACT_APP_API_HOST;
}

axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

const app = (
  <Provider store={store}>
    <Browser>
      <App />
    </Browser>
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js